import cleaning from "./cleaning";
import schedule from "./schedule";




export default [
    ...cleaning,
    ...schedule

];